(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class MirluxMegaMenu extends HTMLElement {
    constructor() {
      super();
      this._mq = window.matchMedia('(min-width: 1150px)');
      this._onKeydown = this._onKeydown.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.panel = this.querySelector('#mirlux-mega-panel');
      this._portalSlot = document.getElementById('mirlux-portal-slot');

      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.togglePanel());
      }

      const clearClose = () => {
        if (this._closeTimer) { clearTimeout(this._closeTimer); this._closeTimer = null; }
      };
      const scheduleClose = () => {
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._closeTimer = setTimeout(() => {
          this._closeTimer = null;
          this.closePanel();
        }, 200);
      };

      if (this.trigger) {
        this.trigger.addEventListener('mouseenter', () => {
          if (!this._mq.matches) return;
          clearClose();
          this.openPanel();
        });
        this.trigger.addEventListener('mouseleave', () => {
          if (!this._mq.matches) return;
          scheduleClose();
        });
        this.trigger.addEventListener('focus', () => {
          // FR: closePanel(true) restores focus here; don't let that re-open the panel.
          if (this._mq.matches && !this._restoringFocus) this.openPanel();
        });
      }

      if (this.panel) {
        this.panel.addEventListener('mouseenter', () => {
          if (!this._mq.matches) return;
          clearClose();
        });
        this.panel.addEventListener('mouseleave', () => {
          if (!this._mq.matches) return;
          scheduleClose();
        });
      }

      if (this._portalSlot) {
        this._portalSlot.addEventListener('click', e => {
          const r = e.target.closest('[data-rail]');
          if (!r) return;
          if (r.dataset.url && e.target.closest('.mirlux-mega__rail-label')) {
            window.location.href = r.dataset.url;
            return;
          }
          this.activateRailItem(r);
        });
        this._portalSlot.addEventListener('mouseover', e => {
          const r = e.target.closest('[data-rail]');
          if (r && this._mq.matches) this.activateRailItem(r);
        });
      }

      document.addEventListener('click', e => {
        const dt = e.target.closest('.mirlux-drawer-assortment__trigger');
        if (dt) { this._toggleDrawerTree(dt); return; }
        const dr = e.target.closest('.mirlux-drawer-body [data-rail]');
        if (dr && !this._mq.matches) {
          if (dr.dataset.url && e.target.closest('.mirlux-mega__rail-label')) {
            window.location.href = dr.dataset.url;
            return;
          }
          this.activateRailItem(dr);
          return;
        }
        if (this.panel && !this.panel.hidden) {
          if (!this.contains(e.target) && !this.panel.contains(e.target)) {
            this.closePanel();
          }
        }
      });

      document.addEventListener('keydown', this._onKeydown);

      requestAnimationFrame(() => {
        this._mq.addEventListener('change', e => {
          if (e.matches) this._portal(); else this._unportal();
        });
        if (this._mq.matches) this._portal();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
    }

    _portal() {
      const tree = document.getElementById('mirlux-tree-mount');
      if (!tree || !this._portalSlot) return;
      this._portalSlot.appendChild(tree);
      tree.hidden = false;
      const first = this._portalSlot.querySelector('[data-rail]');
      if (first) this.activateRailItem(first);

      const navBar = this.querySelector('.mirlux-mega__nav-bar');
      if (navBar) {
        document.querySelectorAll('[data-mirlux-desktop-link]').forEach(el => {
          el._origParent = el.parentElement;
          el._origNext = el.nextSibling;
          navBar.appendChild(el);
          el.hidden = false;
        });
      }
    }

    _unportal() {
      const tree = document.getElementById('mirlux-tree-mount');
      const drawerAssortment = document.querySelector('.mirlux-drawer-assortment');
      if (tree && drawerAssortment) {
        drawerAssortment.appendChild(tree);
        tree.hidden = false;
        const trigger = drawerAssortment.querySelector('.mirlux-drawer-assortment__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }

      document.querySelectorAll('[data-mirlux-desktop-link]').forEach(el => {
        el.hidden = true;
        if (el._origParent) {
          el._origParent.insertBefore(el, el._origNext || null);
        }
      });

      this.closePanel();
    }

    _toggleDrawerTree(triggerEl) {
      const tree = document.getElementById('mirlux-tree-mount');
      if (!tree) return;
      const willOpen = tree.hidden;
      tree.hidden = !willOpen;
      triggerEl.setAttribute('aria-expanded', String(willOpen));
    }

    togglePanel() {
      const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
      isOpen ? this.closePanel() : this.openPanel();
    }

    openPanel() {
      if (!this.panel) return;
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
    }

    closePanel(restoreFocus = false) {
      if (!this.panel) return;
      if (this._closeTimer) { clearTimeout(this._closeTimer); this._closeTimer = null; }
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
      if (restoreFocus && this.trigger) {
        this._restoringFocus = true;
        this.trigger.focus();
        this._restoringFocus = false;
      }
    }

    activateRailItem(activeItem) {
      const activeCat = activeItem.dataset.cat;
      const allRail = Array.from(document.querySelectorAll('[data-rail]'));
      const allPanes = Array.from(document.querySelectorAll('[data-pane]'));
      const isDesktop = this._mq.matches;

      if (!isDesktop) {
        const pane = allPanes.find(p => p.dataset.cat === activeCat);
        if (pane) {
          const willOpen = !pane.classList.contains('is-active');
          allPanes.forEach(p => {
            if (p !== pane) {
              p.hidden = true;
              p.classList.remove('is-active');
            }
          });
          allRail.forEach(r => {
            if (r !== activeItem) {
              r.classList.remove('is-active');
              r.setAttribute('aria-selected', 'false');
            }
          });
          pane.hidden = !willOpen;
          pane.classList.toggle('is-active', willOpen);
          activeItem.classList.toggle('is-active', willOpen);
          activeItem.setAttribute('aria-selected', String(willOpen));
        }
        return;
      }

      allRail.forEach(r => {
        const a = r.dataset.cat === activeCat;
        r.classList.toggle('is-active', a);
        r.setAttribute('aria-selected', String(a));
      });
      allPanes.forEach(p => {
        const a = p.dataset.cat === activeCat;
        p.hidden = !a;
        p.classList.toggle('is-active', a);
      });
    }

    _onKeydown(e) {
      if (e.key === 'Escape') {
        // FR: only react while the panel is open (mirlux-nl also runs this when closed, stealing focus).
        if (this.panel && !this.panel.hidden) this.closePanel(true);
        return;
      }
      if (!this.panel || this.panel.hidden) return;
      const allRail = Array.from(this._portalSlot?.querySelectorAll('[data-rail]') || []);
      const focusedRail = allRail.find(item => item === document.activeElement);
      if (!focusedRail) return;
      const idx = allRail.indexOf(focusedRail);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const next = allRail[idx + 1];
        if (next) { next.focus(); this.activateRailItem(next); }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = allRail[idx - 1];
        if (prev) { prev.focus(); this.activateRailItem(prev); }
      }
    }
  }

  if (!customElements.get('mirlux-mega-menu')) {
    customElements.define('mirlux-mega-menu', MirluxMegaMenu);
  }

  } catch(e) { console.error(e); }
})();
})();
